import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'
import { SectionHeading } from '../../Styles/style'

import arrow from "../../../assets/images/arrow.png"

import chrome from "../../../assets/images/chrome.png"
import edge from "../../../assets/images/edge.png"
const SectionWrapper = styled.div`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
place-content: center;
flex-direction: column;
align-items: center;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    /* padding: ${(props) => (props.p799 ? props.p799 : "30px 0")}; */
  }
  @media screen and (max-width: 599px) {
    /* padding: ${(props) => (props.p599 ? props.p599 : "30px 0")}; */
  }
`;
const ConnectButt = styled.a`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.btnPrimary)};
display: flex;
align-items: center;
text-align: center;
place-content: center;
margin: ${(props) => (props.m ? props.m : "")};
padding: ${(props) => (props.p ? props.p : "11px 30px")};
font-family: "Poppins-Medium";
font-size: 15px;
color: ${(props) => props.theme.textPrimary};
text-decoration:none ;
cursor: pointer;
border: 1px solid ${(props) => (props.border ? props.border : props.theme.textPriamry)};
@media screen and (max-width:599px){
  padding: ${(props) => (props.p ? props.p : "11px 10px")};

}
`
const BtnDIv = styled.div`
display: flex;
align-items:center ;
gap: 3px;
padding: 40px 0;
`
const Availible = (props) => {
  const theme = useTheme();
  return (
    <div>
      <SectionWrapper p="8rem 0" bgcolor={theme.bgTertiary}>
        <SectionHeading align="center" color={theme.textSecondary} data-aos="zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="1000">Avaiable On</SectionHeading>
        <BtnDIv>
          <img src={chrome} alt='' data-aos="zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-offset="0"
            data-aos-duration="1000" />
          <img src={edge} alt=''  data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-offset="0"
              data-aos-duration="1000" />
        </BtnDIv>
        <ConnectButt href='/comingsoon'  data-aos="zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="1000"
          data-aos-offset="0"
          data-aos-duration="1000">Install Incognito For Chrome &nbsp;<img src={arrow} alt=''/></ConnectButt>

      </SectionWrapper>
    </div>
  )
}

export default Availible